const SHOW_WELCOME = "welcome:SHOW_WELCOME";
const HIDE_WELCOME = "welcome:HIDE_WELCOME";
const UPDATE_ALL = "welcome:UPDATE_ALL";
const UPDATE_RECENT_FILES = "welcome:UPDATE_RECENT_FILES";
const UPDATE_EXAMPLE_FILES = "welcome:UPDATE_EXAMPLE_FILES";
const UPDATE_STANDARD_TEMPLATES = "welcome:UPDATE_STANDARD_TEMPLATES";
const UPDATE_CUSTOM_TEMPLATES = "welcome:UPDATE_CUSTOM_TEMPLATES";
const DELETE_CUSTOM_TEMPLATE = "welcome:DELETE_CUSTOM_TEMPLATE";
const SHOW_UPGRADE_WIZARD = "welcome:SHOW_UPGRADE_WIZARD";
const HIDE_UPGRADE_WIZARD = "welcome:HIDE_UPGRADE_WIZARD";
const SHOW_TEMPLATE_WIZARD = "welcome:SHOW_TEMPLATE_WIZARD";
const HIDE_TEMPLATE_WIZARD = "welcome:HIDE_TEMPLATE_WIZARD";
const SHOW_LOADING_FILE = "welcome:SHOW_LOADING_FILE";
const HIDE_LOADING_FILE = "welcome:HIDE_LOADING_FILE";

export const actionTypes = {
  SHOW_WELCOME,
  HIDE_WELCOME,
  UPDATE_ALL,
  UPDATE_RECENT_FILES,
  UPDATE_EXAMPLE_FILES,
  UPDATE_STANDARD_TEMPLATES,
  UPDATE_CUSTOM_TEMPLATES,
  DELETE_CUSTOM_TEMPLATE,
  SHOW_UPGRADE_WIZARD,
  HIDE_UPGRADE_WIZARD,
  SHOW_TEMPLATE_WIZARD,
  HIDE_TEMPLATE_WIZARD,
  SHOW_LOADING_FILE,
  HIDE_LOADING_FILE
};

const showWelcome = () => {
  return {
    type: SHOW_WELCOME
  };
};

const hideWelcome = () => {
  return {
    type: HIDE_WELCOME
  };
};

const showLoadingFile = () => {
  return {
    type: SHOW_LOADING_FILE
  };
};

const hideLoadingFile = () => {
  return {
    type: HIDE_LOADING_FILE
  };
};

const updateAll = data => {
  return {
    type: UPDATE_ALL,
    data
  };
};

const updateRecentFiles = data => {
  return {
    type: UPDATE_RECENT_FILES,
    data
  };
};

const updateExampleFiles = data => {
  return {
    type: UPDATE_EXAMPLE_FILES,
    data
  };
};

const updateStandardTemplates = data => {
  return {
    type: UPDATE_STANDARD_TEMPLATES,
    data
  };
};

const updateCustomTemplates = data => {
  return {
    type: UPDATE_CUSTOM_TEMPLATES,
    data
  };
};

const deleteCustomTemplate = data => {
  return {
    type: DELETE_CUSTOM_TEMPLATE,
    data
  };
};

const showUpgradeWizard = data => {
  return {
    type: SHOW_UPGRADE_WIZARD,
    data
  };
};

const hideUpgradeWizard = data => {
  return {
    type: HIDE_UPGRADE_WIZARD,
    data
  };
};

const showTemplateWizard = data => {
  return {
    type: SHOW_TEMPLATE_WIZARD,
    data
  };
};

const hideTemplateWizard = data => {
  return {
    type: HIDE_TEMPLATE_WIZARD,
    data
  };
};

export default {
  showWelcome,
  hideWelcome,
  showLoadingFile,
  hideLoadingFile,
  updateAll,
  updateRecentFiles,
  updateExampleFiles,
  updateStandardTemplates,
  updateCustomTemplates,
  deleteCustomTemplate,
  showUpgradeWizard,
  hideUpgradeWizard,
  showTemplateWizard,
  hideTemplateWizard
};
